module.exports = __webpack_public_path__ + "img/bluetooth.ba2da1a7.png";